export default __webpack_public_path__ + "static/media/Logo.2d2e5929.svg";